export const STAR_ICON_PATH = {
  STROKE:
    'M50 17.94l8.93 19 1.24 2.66 2.91.44 20.51 3.16-15 15.4-1.94 2 .45 2.74 3.49 21.39-17.9-9.9L50 73.34l-2.66 1.47-17.9 9.9 3.49-21.39.45-2.74-1.94-2-15-15.4 20.51-3.14 2.91-.44 1.21-2.6L50 18m0-13L36.09 34.63 5 39.38l22.5 23.06L22.19 95 50 79.63 77.81 95 72.5 62.44 95 39.38l-31.09-4.75L50 5z',
  BG:
    'M50 79.63L22.19 95l5.31-32.56L5 39.38l31.09-4.75L50 5l13.91 29.63L95 39.38 72.5 62.44 77.81 95 50 79.63z'
}
